/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunnelguests3Inputs */

const en_liveroomfunnelguests3 = /** @type {(inputs: Liveroomfunnelguests3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of them guests`)
};

const de_liveroomfunnelguests3 = /** @type {(inputs: Liveroomfunnelguests3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`davon Gäste`)
};

/**
* | output |
* | --- |
* | "of them guests" |
*
* @param {Liveroomfunnelguests3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunnelguests3 = /** @type {((inputs?: Liveroomfunnelguests3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunnelguests3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunnelguests3(inputs)
	return de_liveroomfunnelguests3(inputs)
});
export { liveroomfunnelguests3 as "liveRoomFunnelGuests" }